import { getQuery } from './utils.js';

function fillPredictions(predictions, predictiveSearchWrapper, type, inputValue) {
  const predictionWrapper = document.querySelector('#predictive-search-relewise-sidebar-category-wrapper-template').content.cloneNode(true);
  const predictionItemTemplate = document.querySelector('#predictive-search-relewise-sidebar-category-result-template')
  let suggestionHeader = ''
  if (type == 'collections') suggestionHeader = predictiveSearchWrapper.querySelector('.thb-predictive-search--inner') ? predictiveSearchWrapper.querySelector('.thb-predictive-search--inner').getAttribute('data-ts-collections') : 'Suggested Collections';
  if (type == 'terms') suggestionHeader = predictiveSearchWrapper.querySelector('.thb-predictive-search--inner') ? predictiveSearchWrapper.querySelector('.thb-predictive-search--inner').getAttribute('data-ts-suggestions') : 'Suggested Terms';
  if (type == 'popular-terms') suggestionHeader = predictiveSearchWrapper.querySelector('.thb-predictive-search--inner') ? predictiveSearchWrapper.querySelector('.thb-predictive-search--inner').getAttribute('data-ts-popular-terms') : 'Popular Search Terms';
  predictionWrapper.querySelector('.thb-predictive-search--heading').textContent = suggestionHeader;
  predictionWrapper.querySelector('.sidebar-category-wrapper').classList.add(type);
  if (type == 'collections') predictionWrapper.querySelector('.sidebar-category-wrapper').classList.add('hidden', 'md:block');

  const searchTerm = getQuery(inputValue);

  predictions.forEach((prediction, i) => {
    let predictionItem = predictionItemTemplate.content.cloneNode(true);
    let term = prediction.term || prediction.displayName;

    const termDiv = document.createElement('div');
    const termSpan = document.createElement('span');
    const searchTermIndex = term.toLowerCase().indexOf(searchTerm.toLowerCase());

    if (searchTermIndex !== -1) {
      termDiv.textContent = term.substring(0, searchTermIndex);
      termSpan.textContent = term.substring(searchTermIndex, searchTermIndex + searchTerm.length);
      termDiv.classList.add('text-2xl', 'md:text-lg')
      termSpan.classList.add('search-term', 'font-bold');
      termDiv.appendChild(termSpan);
      termDiv.appendChild(document.createTextNode(term.substring(searchTermIndex + searchTerm.length)));
    } else {
      termDiv.textContent = term;
    }
    predictionItem.querySelector('.thb-predictive-search--query').appendChild(termDiv);
    let href = type === 'collections' ? '/collections/' + prediction?.data?.Handle?.value : '/search?q=' + term;
    predictionItem.querySelector('.thb-predictive-search--query').setAttribute('href', href);

    if (prediction.expectedResultTypes) {
      let hits = 0;
      prediction.expectedResultTypes.forEach((type) => {
        hits = hits + type.estimatedHits;
      });
      let hitSpan = document.createElement('span');
      hitSpan.classList.add('thb-predictive-search--hits', 'md:text-xs', 'text-base', 'items-baseline', 'md:items-start', 'opacity-60', 'md:opacity-100');
      hitSpan.textContent = hits;
      predictionItem.querySelector('.thb-predictive-search--query').appendChild(hitSpan);
    }

    predictionWrapper.querySelector('ul').appendChild(predictionItem);
  });

  predictiveSearchWrapper.querySelector('.thb-predictive-search--sidebar').appendChild(predictionWrapper);

  return predictiveSearchWrapper;
}

export default fillPredictions;